import React from 'react';
import { CmsExperiencePhase } from '../../integrations/contentful/types';
import { IconName } from '../common/Icon';
import Spacing from '../common/Spacing';
import IconText from '../common/IconText';
import H from '../elements/H';
import HorizontalCardList, { VisibleCards } from '../common/HorizontalCardList';
import ExperiencePhaseCard from '../memories/ExperiencePhaseCard';
import DisplayOn from '../common/DisplayOn';
import {
  DesktopHorizontalList,
  getDesktopHorizontalListTopControls
} from '../common/DesktopHorizontalList';
import Row from '../grid/Row';
import Col from '../grid/Col';

interface PhaseListSectionProps {
  phases: CmsExperiencePhase[];
  openDialog: (phase: CmsExperiencePhase) => void;
  title: string;
  iconName: IconName;
}

function renderExperiencePhaseCard(
  phase: CmsExperiencePhase,
  openDialog: (phase: CmsExperiencePhase) => void
) {
  if (!phase.fields.mainMedia) {
    return null;
  }
  return (
    <ExperiencePhaseCard
      onClick={() => {
        openDialog(phase as CmsExperiencePhase);
      }}
      key={phase.sys.id}
      description={phase.fields.title}
      cardTitle={phase.fields.label}
      mainImage={phase.fields.mainMedia}
    />
  );
}

interface IconTextTitleProps {
  iconName: IconName;
  title: string;
}

const IconTextTitle: React.FunctionComponent<IconTextTitleProps> = ({
  iconName,
  title
}) => {
  return (
    <IconText icon={iconName} iconColor="gray" iconSize={3}>
      <H styling="h4" tag="div">
        <strong>{title}</strong>
      </H>
    </IconText>
  );
};

const MobilePhaseList: React.FunctionComponent<{
  phases: CmsExperiencePhase[];
  openDialog: (phase: CmsExperiencePhase) => void;
  iconName: IconName;
  title: string;
}> = ({ phases, openDialog, iconName, title }) => {
  return (
    <>
      <IconTextTitle iconName={iconName} title={title} />
      <Spacing top={3}>
        <HorizontalCardList
          visibleCards={VisibleCards.Two}
          expand
          data-testid="phase-list-mobile"
        >
          {phases.map((phase) => {
            return renderExperiencePhaseCard(phase, openDialog);
          })}
        </HorizontalCardList>
      </Spacing>
    </>
  );
};

const PhaseListSection: React.FunctionComponent<PhaseListSectionProps> = ({
  phases,
  openDialog,
  title,
  iconName
}) => {
  return (
    <Spacing bottom={8}>
      <DisplayOn small medium>
        <MobilePhaseList
          phases={phases}
          openDialog={openDialog}
          iconName={iconName}
          title={title}
        />
      </DisplayOn>
      <DisplayOn large>
        <Row>
          <Col size={24}>
            <DesktopHorizontalList
              elementsPerSlide={4}
              controls={getDesktopHorizontalListTopControls(
                <IconTextTitle iconName={iconName} title={title} />
              )}
            >
              {phases.map((phase) => {
                return renderExperiencePhaseCard(phase, openDialog);
              })}
            </DesktopHorizontalList>
          </Col>
        </Row>
      </DisplayOn>
    </Spacing>
  );
};

export default PhaseListSection;
